import React, { useEffect, useState } from 'react';
import BASE_URL from '../config';
import './BookingDetails.css';

const BookingDetails = () => {
    const [details, setDetails] = useState({
        title: '',
        reference: '',
        days: '',
        details: '',
        daysnights: '',
        detailsend: '',
        type: '',
        destination: []
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const mockData = {
        title: 'Spectacular Krabi and Phuket Getaway',
        reference: '302145',
        days: '5 NIGHTS',
        details: 'Tue, Nov 26, 2024',
        daysnights: '6D / 5N',
        detailsend: 'Sun, Dec 1, 2024 / From New Delhi',
        type: '1 Room | 2 Adults',
        destination: ['Kota', 'Kullu', 'Kai']
    };

    const fetchData = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/booking/:booking_id?user_tour_id=`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setDetails(data || mockData);
        } catch (error) {
            console.error('Fetching data failed, using mock data', error);
            setDetails(mockData);
            setError('Failed to fetch data, showing mock details');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) return <p>Loading booking details...</p>;

    return (
        <div className='booking-details-cont'>
            <div className='booking-det-header'>
                <h2 className='booking-det-title'>{details.title}</h2>
                <p className='booking-det-reference'>Booking Reference No.: #{details.reference}</p>
            </div>
            <div className='night-days'>
            <ul>
                <li>{details.days}</li>
            </ul>
            </div>
            <div className='booking-details-desc'>
                {details.details}
                <div className='details-days-nights-wrapper'>
                    <div className='line-desc-hor'></div>
                    <div className='details-days-nights'>
                        {details.daysnights}
                    </div>
                    <div className='line-desc-hor'></div>
                </div>
                <div className='line-desc'></div>
                <div>{details.detailsend}</div>
            </div>
            <p>Type: {details.type}</p>
            <div>
            <ul className='destination-list'>
                {details.destination.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
            </div>

        </div>
    );
};

export default BookingDetails;
